<script>
  import {styleVars} from '/helper'
  import Card from '/components/Atoms/Card.svelte'
  import IconAudio from '/components/Icons/IconAudio'

  export let title
  export let subtitle
  export let image
  export let image2x
  export let imageWebp
  export let imageWebp2x
  export let category
  export let standardRadius = false
  export let highlight = false
  export let link = null
  export let typeHandle = null
  export let imageContain = false
  export let bgColorKey = null
  export let smallFonts = false

  // $: console.log($$slots.default)
  // console.log(imageWebp)
</script>

<Card bgImage={image} bgImage2x={image2x} bgImageWebp={imageWebp} bgImageWebp2x={imageWebp2x} {standardRadius} {link} {imageContain} {bgColorKey} nohole>
  <div class="container" class:highlight={highlight} class:greenTxt={image && !imageContain} >
    <h2 class="category" class:smallFonts>
      {category || ""}
    </h2>
    <div class="middle">
      <h3 class="title" class:smallFonts>
        {title}
      </h3>
      {#if subtitle}
        <h4 class="subtitle" class:smallFonts>
          {subtitle}
        </h4>
      {/if}
    </div>
    <span class="category">
      {#if typeHandle === "audio"}
        <IconAudio />
      {/if}
    </span>
  </div>
</Card>

<style lang="scss">


  .container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  
  .category {
    &:not(.smallFonts) { @include typo-serif-small-caps-28; }
    &.smallFonts { @include typo-serif-small-caps-28-small; }
    color: $color-red;
    min-height: 1em;
  }

  .middle {
    padding-top: 1ex;
    padding-bottom: 1ex;
    .greenTxt & {
      color: $color-mint;
      text-shadow: 0px 0px 25px #000000;
    }
  }



  .title {
    &:not(.smallFonts) {
      @include typo-grotesk-title-30;

      .highlight & {
        @include typo-grotesk-title-50;
      }
    }
    &.smallFonts {
      @include typo-grotesk-title-30-small;

      .highlight & {
        @include typo-grotesk-title-50-small;
      }
    }    

  }

  .subtitle {
    &:not(.smallFonts) { @include typo-grotesk-text-24; }
    &.smallFonts { @include typo-grotesk-text-24-small; }
  }

</style>